/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import drag from './drag'
import user from './user'
import topBar from './top-bar'
import websocket from './websocket'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        appConfig,
        verticalMenu,
        drag,
        user,
        topBar,
        websocket,
    },
    strict: process.env.DEV,
})